import { useMutation, useQueryClient } from "@tanstack/react-query";

import { chatApi } from "@/features/messaging/services/chat.api";

/** Used by `ProductDetailsPage`'s "Message Seller" button — get-or-create
 * the thread for this product, then navigate to it. Idempotent server-side
 * (same buyer + product returns the existing chat), so clicking "Message
 * Seller" on an already-started conversation just resumes it. */
export function useCreateChat() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: chatApi.createOrGetChat,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["conversations"] });
    },
  });
}
